import { regexCapitalLetters, regexLowerLetters, regexOneNumber, regexSpecialChar } from "@utils/utils";

export type PasswordStrengthColor = "default" | "danger" | "warningO" | "success" | "primary" | "secondary" | undefined;

export function usePasswordStrengthBar(password: string) {
  function passwordStrengthLevel(password: string) {
    const strength = {
      hasUpperCase: regexCapitalLetters.test(password),
      hasLowerCase: regexLowerLetters.test(password),
      hasNumber: regexOneNumber.test(password),
      hasSpecialChar: regexSpecialChar.test(password),
      isLongEnough: password.length >= 8,
    };

    const strengthLevel = Object.values(strength).filter(Boolean).length;

    return strengthLevel;
  }

  const passwordStrengthTitle = () => {
    const strengthLevel = passwordStrengthLevel(password);
    const titles: string[] = ["", "Fraca", "Fraca", "Média", "Média", "Forte"];
    return titles[strengthLevel];
  };

  const passwordStrengthColor = () => {
    const strengthLevel = passwordStrengthLevel(password);
    const colors: PasswordStrengthColor[] = ["default", "danger", "danger", "warningO", "warningO", "success"];
    return colors[strengthLevel];
  };

  return {
    passwordStrengthLevel,
    passwordStrengthTitle,
    passwordStrengthColor,
  };
}
